import * as React from 'react';
import { cn } from './cn';

// TextArea is bottom-of-stack — geometry/focus/disabled inline. Input
// and Select bake the same shape independently; drift is visible in
// code review, not hidden behind a shared module.
//
// `wm-field` and the CSS variables are read by Form.jsx for label /
// fieldset offsets — keep them on the rendered element.
const WM_FIELD_GEOMETRY_CLASSNAME = 'wm-field [--wm-field-border-width:1px] [--wm-field-margin:0px] [--wm-field-padding-x:0.75rem] [--wm-field-padding-y:0.5rem]';

const WM_FIELD_FOCUS_CLASSNAME = 'focus:tw-border-muted-foreground focus:tw-outline-none focus:tw-ring-0 focus:tw-ring-offset-0 focus-visible:tw-border-muted-foreground focus-visible:tw-outline-none focus-visible:tw-ring-0 focus-visible:tw-ring-offset-0';

// `size` only changes typography + padding — height is content-driven
// via `min-h-textarea`, so the same min-height holds for every stop.
// Canonical scale shared with Button / IconButton / Select / Input.
const WM_FIELD_SIZE_CLASSNAMES = {
    small: 'tw-px-2.5 tw-py-1 tw-text-xs tw-leading-5',
    medium: 'tw-px-3 tw-py-2 tw-text-sm tw-leading-6',
    large: 'tw-px-3.5 tw-py-2.5 tw-text-sm tw-leading-6'
};

const TextArea = React.forwardRef(({ className: _className, style: _style, size = 'medium', ...props }, ref) => {
    const resolvedSize = WM_FIELD_SIZE_CLASSNAMES[size] ? size : 'medium';

    return (
        <textarea
            className={cn(
                WM_FIELD_GEOMETRY_CLASSNAME,
                WM_FIELD_SIZE_CLASSNAMES[resolvedSize],
                WM_FIELD_FOCUS_CLASSNAME,
                'tw-m-0 tw-block tw-min-h-textarea tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-text-foreground tw-transition-colors placeholder:tw-text-muted-foreground disabled:tw-cursor-not-allowed disabled:tw-opacity-50'
            )}
            ref={ref}
            {...props}
        />
    );
});
TextArea.displayName = 'TextArea';

export { TextArea };
